<template>
    
    <div>    

    <table class="table table-striped">

    <thead>

        <tr>

            <!--<th>ID</th>-->
            <th>
            
                <div class="d-flex flex-row">

                <input class="form-control m-2"
                v-model="ReferenciaFilter"
                v-on:keyup="FilterFn()"
                placeholder="Filtrar">
                
                <button type="button" class="btn btn-light"
                @click="sortResult('Referencia',true)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
                </svg>
                </button>
                &nbsp;
                <button type="button" class="btn btn-light"
                @click="sortResult('Referencia',false)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
                </svg>
                </button>

                </div>

                Referencias
            
            </th>

        </tr>

    </thead>

    <tbody>
        <tr v-for="(ref, index) in referencias" :key="index">

            <!--<td>{{ref.ReferenciaID}}</td>-->
            <td>{{ref.Referencia}}</td>

        </tr>
    </tbody>

    </table>

    </div>

</template>

<script>

import axios from 'axios';

export default{

    data(){

    return{
        referencias:[],
        ReferenciaFilter:"",
        ReferenciaIDFilter:"",
        ReferenciasWithoutFilter:[]
    }
    },

    methods:{
        refreshData(){
            axios.get("http://difraco.com.co:8000/referencia")
            .then((response)=>{
                this.referencias=response.data;
                this.referenciasWithoutFilter=response.data;
            })
        },

        FilterFn(){
            var ReferenciaIDFilter=this.ReferenciaIDFilter;
            var ReferenciaFilter=this.ReferenciaFilter;

            this.referencias=this.referenciasWithoutFilter.filter(
                function(el){
                    return el.ReferenciaID.toString().toLowerCase().includes(
                        ReferenciaIDFilter.toString().trim().toLowerCase()
                    )&&
                    el.Referencia.toString().toLowerCase().includes(
                        ReferenciaFilter.toString().trim().toLowerCase()
                    )
                });
        },
        sortResult(prop,asc){
            this.referencias=this.referenciasWithoutFilter.sort(function(a,b){
                if(asc){
                    return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
                }
                else{
                    return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
                }
            })
        },

    },

    mounted:function(){
        this.refreshData();
    }

    };

</script>
